import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-background-100">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-500/5 via-transparent to-transparent"></div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-6">
            <i className="ri-sparkling-2-fill text-sm"></i>
            已收录 500+ 优质h漫资源
          </div>
          <h1 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight mb-6">
            探索<span className="text-primary-500">h漫</span>的世界<br />
            <span className="text-foreground-700">发现属于你的精彩</span>
          </h1>
          <p className="text-base md:text-lg text-foreground-500 leading-relaxed mb-8 max-w-2xl mx-auto">
            汇聚海量h漫资源、风格分类与深度解读。无论你是h漫新手还是资深爱好者，
            这里提供专业的h漫导览与热门推荐，助你快速找到心仪内容。
          </p>

          {/* Quick Category Pills */}
          <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="px-4 py-2 rounded-full bg-background-50 border border-background-300/60 text-sm text-foreground-600 hover:text-primary-600 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {/* CTA */}
          <Link
            to="/category/japanese"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white text-base font-medium rounded-lg whitespace-nowrap transition-colors cursor-pointer shadow-lg shadow-primary-500/20"
          >
            <i className="ri-search-line text-lg"></i>
            开始探索h漫
          </Link>
        </div>
      </div>
    </section>
  );
}